import type { Metadata, Viewport } from 'next'

export const metadata: Metadata = {
  title: 'RateRight HQ',
  description: 'CEO Dashboard',
  robots: 'noindex, nofollow',
}

export const viewport: Viewport = {
  themeColor: '#030712',
  width: 'device-width',
  initialScale: 1,
}

export default function CEOLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      {/* Fixed bottom nav for CEO pages */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-gray-950/95 backdrop-blur border-t border-white/10 px-2 py-2 flex justify-around max-w-lg mx-auto">
        <a href="/ceo" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">🤖</span>
          <span className="text-[9px]">Fleet</span>
        </a>
        <a href="/ceo/metrics" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">📊</span>
          <span className="text-[9px]">Metrics</span>
        </a>
        <a href="/ceo/feedback" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">💬</span>
          <span className="text-[9px]">Feedback</span>
        </a>
        <a href="/ceo/success" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">🏆</span>
          <span className="text-[9px]">Success</span>
        </a>
        <a href="/ceo/faq" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">📖</span>
          <span className="text-[9px]">FAQ</span>
        </a>
        <a href="/ceo/experiments" className="flex flex-col items-center gap-0.5 text-gray-400 hover:text-white transition py-1 px-1">
          <span className="text-base">🧪</span>
          <span className="text-[9px]">A/B</span>
        </a>
      </nav>
    </>
  )
}
